import { api } from "@/lib/api";

import type {
  CreateRiderPayrollReq,
  MarkRiderPayrollPaidReq,
  RiderPayroll,
  RiderPayrollList,
  RiderPayrollStatus,
  UpdateRiderPayrollReq,
} from "@artisancode/api-types";

export interface RiderPayrollListParams {
  page?: number;
  per_page?: number;
  rider_id?: string;
  status?: RiderPayrollStatus;
  date_from?: string;
  date_to?: string;
  workspace_id?: string;
}

export const riderPayrollService = {
  list: (params?: RiderPayrollListParams) =>
    api.get<RiderPayrollList>(
      "/rider-payrolls",
      params as Record<string, string | number | boolean | undefined>,
    ),

  create: (body: CreateRiderPayrollReq, idempotencyKey?: string) =>
    api.post<RiderPayroll>(
      "/rider-payrolls",
      body,
      idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
    ),

  update: (id: string, body: UpdateRiderPayrollReq) =>
    api.patch<RiderPayroll>(`/rider-payrolls/${id}`, body),

  markPaid: (id: string, body: MarkRiderPayrollPaidReq) =>
    api.post<RiderPayroll>(`/rider-payrolls/${id}/mark-paid`, body),

  cancel: (id: string, reason: string) =>
    api.del<RiderPayroll>(`/rider-payrolls/${id}`, { reason }),
};
